import axios from 'axios'

export default {
    async sampleExcel() {
        return await axios.get(`lang/sample-excel-language`,{
            responseType: 'blob'
        });
    },
    async excelImport(payload){
        return await axios.post(`lang/import-excel-language`,payload);
    }
  
}
